import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiEdit,
  FiShield,
  FiUser,
  FiCheck,
  FiX,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function RolesPermissions() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [roles] = useState([
    {
      id: 1,
      roleName: "Super Admin",
      description: "Full system access",
      userCount: 2,
      permissions: ["All Permissions"],
      isSuperAdmin: true,
    },
    {
      id: 2,
      roleName: "Admin",
      description: "Administrative access",
      userCount: 5,
      permissions: ["User Management", "Content Management", "Ticket Management"],
      isSuperAdmin: false,
    },
    {
      id: 3,
      roleName: "Analyst",
      description: "Content creation and editing",
      userCount: 8,
      permissions: ["Content Creation", "Content Editing"],
      isSuperAdmin: false,
    },
    {
      id: 4,
      roleName: "Reviewer",
      description: "Content approval",
      userCount: 3,
      permissions: ["Content Approval", "Content Review"],
      isSuperAdmin: false,
    },
  ]);

  const [permissions] = useState([
    "User Management",
    "KYC Review",
    "Bank Verification",
    "Content Management",
    "Content Approval",
    "Ticket Management",
    "Billing Management",
    "Agent Management",
    "Commission Management",
    "Security Management",
    "CMS Management",
    "Integration Management",
  ]);

  const handleCreateRole = () => {
    Swal.fire({
      title: "Create New Role",
      html: `
        <input id="roleName" class="swal2-input" placeholder="Role Name" required>
        <textarea id="roleDescription" class="swal2-textarea" placeholder="Description"></textarea>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Create Role",
      confirmButtonColor: "#006e82",
    });
  };

  const handleAssignPermissions = (roleId) => {
    const role = roles.find((r) => r.id === roleId);
    Swal.fire({
      title: `Assign Permissions to ${role.roleName}`,
      html: `
        <div style="text-align: left; max-height: 300px; overflow-y: auto;">
          ${permissions.map(
            (perm) => `
            <label style="display: block; margin: 8px 0;">
              <input type="checkbox" id="perm_${perm.replace(/\s+/g, "_")}" ${role.permissions.includes(perm) ? "checked" : ""}>
              ${perm}
            </label>
          `
          ).join("")}
        </div>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Save Permissions",
      confirmButtonColor: "#006e82",
      width: "500px",
    });
  };

  const handleAssignToUsers = (roleId) => {
    Swal.fire({
      title: "Assign Role to Users",
      html: `
        <input id="userIds" class="swal2-input" placeholder="Enter user IDs (comma-separated)" required>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Assign Role",
      confirmButtonColor: "#006e82",
    });
  };

  const filteredRoles = roles.filter((role) => {
    return role.roleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      role.description.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRoles.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredRoles.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="content-page-header content-page-headersplit">
                <h5>Roles & Permissions</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/security/roles-permissions">Security</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Roles & Permissions
                  </li>
                </ol>
              </nav>
         
           
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by role name or description..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button
                    className="btn btn-primary"
                    onClick={handleCreateRole}
                  >
                    <i className="fas fa-plus me-2"></i>
                    Create Role
                  </button>
              </div>
              </div>
            </div>

            {/* Roles Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Role Name</th>
                          <th>Description</th>
                          <th>Users</th>
                          <th>Permissions</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="5">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((role) => (
                            <tr key={role.id}>
                              <td style={{ fontWeight: "500" }}>
                                <div className="d-flex align-items-center">
                                  <i className="fas fa-shield-alt me-2" style={{ color: "#006e82" }}></i>
                                  {role.roleName}
                                  {role.isSuperAdmin && (
                                    <span className="badge-pending ms-2">
                                      Super Admin
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td>{role.description}</td>
                              <td style={{ fontWeight: "600" }}>{role.userCount}</td>
                              <td>
                                <div className="d-flex flex-wrap gap-1">
                                  {role.permissions.slice(0, 3).map((perm, idx) => (
                                    <span key={idx} className="badge" style={{
                                      background: "#f0f9ff",
                                      color: "#006e82",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                    }}>
                                      {perm}
                                    </span>
                                  ))}
                                  {role.permissions.length > 3 && (
                                    <span className="badge" style={{
                                      background: "#ccf1f7",
                                      color: "#006e82",
                                      padding: "4px 8px",
                                      borderRadius: "4px",
                                      fontSize: "11px",
                                    }}>
                                      +{role.permissions.length - 3} more
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  {!role.isSuperAdmin && (
                                    <>
                                      <div
                                        className="delete-table me-2"
                                        onClick={() => handleAssignPermissions(role.id)}
                                        title="Assign Permissions"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-shield-alt"></i>
                                      </div>
                                      <div
                                        className="delete-table"
                                        onClick={() => handleAssignToUsers(role.id)}
                                        title="Assign to Users"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-user"></i>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
